<template>
  <div class="spinner">
    <div class="loader"></div>
  </div>
</template>

<script>

export default {
  name: "Spinner",
};
</script>
